import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateSalesforceTaskActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail'
}) => {
  const subject = actionMetadata.subject || /*#__PURE__*/_jsx(MissingLabel, {
    type: "subject"
  });
  const options = {
    subject: /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: subject
    })
  };
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-salesforce-task.action-detail.content",
    options: options
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-salesforce-task.action-preview.content",
    options: options
  });
};
export default CreateSalesforceTaskActionDetail;